import { render, staticRenderFns } from "./OzMenuRows.vue?vue&type=template&id=078f4434&"
import script from "./OzMenuRows.vue?vue&type=script&lang=ts&"
export * from "./OzMenuRows.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports